import { render, staticRenderFns } from "./ClickMenu.vue?vue&type=template&id=66cf8d9f&scoped=true"
import script from "./ClickMenu.vue?vue&type=script&lang=js"
export * from "./ClickMenu.vue?vue&type=script&lang=js"
import style0 from "./ClickMenu.vue?vue&type=style&index=0&id=66cf8d9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf8d9f",
  null
  
)

export default component.exports